export const LEGAL_UPDATED = "October 18, 2026";

const SECTIONS = [
  {
    title: "1. For personal analysis and education only",
    body: "Rockafeller Jones (the \"Site\", including its website, application, AI assistant \"Woodrow\", emails and all related content) is built for personal analysis, research, education and entertainment. Nothing on the Site is, or should be taken as, financial, investment, tax, legal, accounting or any other professional advice, or as a recommendation or offer to buy or sell any security, cryptocurrency or other asset.",
  },
  {
    title: "2. Simulated trading — no real money",
    body: "All Woodrow portfolios, trades, balances, leaderboard rankings and performance figures are simulated. No real orders are placed and no real money is managed. Simulated results have inherent limitations and do not reflect actual trading, liquidity, fees, taxes or slippage. Past or simulated performance is not indicative of future results.",
  },
  {
    title: "3. Data may be delayed or inaccurate",
    body: "Market prices, charts, news and other data come from third-party sources (such as Finnhub, Yahoo Finance and CoinGecko) and may be delayed, incomplete or wrong. AI-generated analysis can be mistaken. We make no warranty of any kind, express or implied, as to the accuracy, completeness, timeliness or fitness for any purpose of any information on the Site. The Site is provided \"as is\" and \"as available\".",
  },
  {
    title: "4. Your decisions are your own",
    body: "Investing involves risk, including the possible loss of principal. You alone are responsible for your investment decisions. Always do your own research and consult a licensed financial professional before making any financial decision.",
  },
  {
    title: "5. Limitation of liability",
    body: "To the fullest extent permitted by law, Rockafeller Jones, its owners, operators and contributors shall not be liable for any loss or damage of any kind — direct, indirect, incidental, consequential, special or punitive, including lost profits or lost data — arising from or related to your use of, or reliance on, the Site or any information on it, even if advised of the possibility of such damages. Use of the Site is entirely at your own risk.",
  },
  {
    title: "6. Copyright",
    body: "© 2025–2026 Rockafeller Jones. All rights reserved. The Site's design, text, graphics, code and branding are protected by copyright and may not be copied, reproduced or redistributed without written permission. Third-party names, logos and data remain the property of their respective owners.",
  },
  {
    title: "7. Changes",
    body: "We may update this notice at any time. Continued use of the Site after changes means you accept the updated terms.",
  },
];

export default function LegalText() {
  return (
    <div className="space-y-5" data-testid="legal-text">
      {SECTIONS.map(s => (
        <section key={s.title}>
          <h2 className="font-heading text-lg text-bt-text-primary mb-1.5">{s.title}</h2>
          <p className="text-sm text-bt-text-secondary leading-relaxed">{s.body}</p>
        </section>
      ))}
      <p className="text-[11px] font-mono text-bt-text-tertiary">Last updated {LEGAL_UPDATED}</p>
    </div>
  );
}
